import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRDemandTotal({
  demand,
  totals,
}) {
  return (
    <Table size="small">
      <TableBody>
        <TableRow
          sx={{
            bgcolor: "secondary.light",

            "& td": {
              fontWeight: 700,
              borderTop: "2px solid",
              borderBottom: "2px solid",
              borderColor: "secondary.main",
              whiteSpace: "nowrap",
            },
          }}
        >

          <TableCell align="left">
            TOTAL OF {demand}
          </TableCell>

          <TableCell />

          <TableCell align="right">
            <CurrencyCell value={totals.dl} />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell value={totals.ds} />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell value={totals.ocl} />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell value={totals.ocs} />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell value={totals.total} />
          </TableCell>

        </TableRow>
      </TableBody>
    </Table>
  );
}